<template>
  <YandexMap
    v-if="centerCoords"
    v-model="map"
    :settings="{
      location: {
        bounds: locationBounds,
      },
      margin: [115, 0, 0, 0],
      behaviors: ['drag', 'pinchZoom', 'dblClick'],
    }"
    width="100%"
    height="100%"
  >
    <YandexMapDefaultSchemeLayer />
    <YandexMapDefaultFeaturesLayer />
    <YandexMapControls :settings="{ position: 'right' }">
      <YandexMapControl>
        <div class="ymaps3--zoom-control ymaps3--zoom-control_vertical">
          <YandexMapControlButton :settings="{ onClick: () => zoomBy(1) }">
            <div class="ymaps3--zoom-control__in" />
          </YandexMapControlButton>
          <YandexMapControlButton :settings="{ onClick: () => zoomBy(-1) }">
            <div class="ymaps3--zoom-control__out" />
          </YandexMapControlButton>
        </div>
      </YandexMapControl>
    </YandexMapControls>

    <YandexMapMarker
      v-for="(pin, pIndex) in offices"
      :key="pIndex"
      :settings="{ coordinates: [pin.longitude as number, pin.latitude as number] }"
    >
      <img
        :src="pIndex === activeTab ? mapPinActive : mapPin"
        :style="{
          minWidth: pIndex === activeTab ? '74px' : '50px',
          position: 'relative',
          boxSizing: 'border-box',
          transform: 'translate(-50%, calc(-50% - 24px))',
          cursor: 'pointer',
          transition: '.2s linear',
        }"
        :alt="pin.title"
        @click="$emit('open-tab', pIndex)"
      />
    </YandexMapMarker>
  </YandexMap>
</template>

<script setup lang="ts">
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapControls,
  YandexMapControl,
  YandexMapControlButton,
  YandexMapMarker,
  YandexMapDefaultFeaturesLayer,
} from 'vue-yandex-maps';
import { shallowRef } from '#imports';
import mapPin from '@/assets/images/map-pin.png';
import mapPinActive from '@/assets/images/map-pin-active.png';
import type { YMap } from '@yandex/ymaps3-types';
import type { ImageItem } from '~/types/pages';

interface OfficePin {
  title: string;
  latitude: number;
  longitude: number;
  image?: ImageItem;
}

defineProps<{
  offices: OfficePin[];
  activeTab: number;
  centerCoords: { latitude: number; longitude: number } | null;
  locationBounds: number[][];
}>();

defineEmits<{
  'open-tab': [index: number];
}>();

const map = shallowRef<YMap | null>(null);

const zoomBy = (delta: number) => {
  if (!map.value) return;

  map.value.update({
    location: {
      zoom: map.value.zoom + delta,
      duration: 200,
    },
  });
};
</script>
